export const resources = {
  KeyframeProfilePictureLabel: ''
};
